/**
 * Создать недостающее, не бросая начатое (14.10.2026).
 *
 * Человек записывает операцию и видит, что нужного счёта или цели нет.
 * Уходить ради этого в «Деньги» — значит потерять набранное. Поэтому в окне
 * выбора счёта, цели и долга есть «+ Новый счёт», «+ Новая цель» и «+ Новый
 * долг»: форма
 * открывается поверх, а созданное сразу выбирается. У категорий так было
 * всегда — «+» в выборе категории.
 *
 * Формы живут в `app.tsx`; окна выбора — в своих файлах и о формах не знают.
 * Связь — через контекст: приложение кладёт сюда, как нарисовать форму.
 */
import { createContext, type ReactNode } from 'react';
import type { Account } from '@skoka/core';

/** Нарисовать форму нового счёта. `done(account)` — создан, `done(null)` — передумал. */
export type CreateAccount = (done: (account: Account | null) => void) => ReactNode;
/** Нарисовать форму новой цели. `done(goalId)` — создана, `done(null)` — передумал. */
export type CreateGoal = (done: (goalId: string | null) => void) => ReactNode;

/** Нарисовать форму нового долга. `done(loanId)` — заведён, `done(null)` — передумал. */
export type CreateDebt = (done: (loanId: string | null) => void) => ReactNode;

export const CreateAccountContext = createContext<CreateAccount | null>(null);
export const CreateGoalContext = createContext<CreateGoal | null>(null);
export const CreateDebtContext = createContext<CreateDebt | null>(null);
